import React, { useEffect, useState ,useRef} from "react";

const CustomFilter = (props) => {
  const [fields, setFields] = useState({});
  const [filterValue, setFilterValue] = useState({});
  const timeoutRef = useRef(null);
  const [text, setText] = useState("");

  useEffect(() => {
    setFields(props.colDef);
  }, [props]);

  const onInputChange = (event) => {
    const {name,value} = event.target;
    setFilterValue({[name]:value});


  };

  useEffect(() => {
    const id = setTimeout(() => {
      if (Object.keys(filterValue).length > 0) {
        props.colDef.filterParams.filter(props, filterValue);
      }
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [filterValue]);

  const fetchFilteredData = async (value) => {
    try {
      console.log("check chek")
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  if (fields.attribute_type === "text") {
    return (
      <div>
        <input type="text" className="form-control" value={filterValue[fields.field]} name={fields.field} onChange={onInputChange}/>
      </div>
    );
  }

  return (
    <div>
      <input type="text" className="form-control" value={filterValue[fields.field]} name={fields.field} onChange={onInputChange}/>
    </div>
  );

};

export default CustomFilter;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/CustomFilter.js